export default __webpack_public_path__ + "static/media/rtg-1.70b82882.svg";